import React, { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Loading,
  Tooltip,
  TooltipUtils,
  ToastContainer
} from 'mailup-web-components'
import './EmailSendingQueueManageStyle.scss'
import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import Header from 'Pages/EmailSendingQueueManage/components/Header'
import SenderBox from 'Pages/EmailSendingQueueManage/components/SenderBox'
import EstimatedTimeBox from 'Pages/EmailSendingQueueManage/components/EstimatedTimeBox'

import { pageState } from 'Pages/EmailSendingQueueManage/recoil/state/page'
import {
  initCallback,
  cleanupCallback
} from 'Pages/EmailSendingQueueManage/recoil/callbacks/callbacks'
import { useParams } from 'react-router-dom'
import Footer from './components/Footer'

import ManageRecipients from './components/ManageRecipients'
import GracePeriodWarning from './components/GracePeriodWarning'
import PecPlusError from './components/PecPlusError'
import PecPlusInProgress from './components/PecPlusInProgress'
import { evalCondition } from 'mailup-react-helpers'
import BoxSheduleSending from './components/BoxSheduleSending/BoxSheduleSending'
import BoxFasciaDiNonDisturbo from './components/BoxFasciaDiNonDisturbo/BoxFasciaDiNonDisturbo'

const EmailSendingQueueManage = () => {
  const { idSending } = useParams()
  const enableSchedulationRedirect = evalCondition('uo:SEND')
  const { loading, loaded, error, severity } = useRecoilValue(pageState)

  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(cleanupCallback, [])

  useEffect(() => {
    return () => {
      cleanup()
    }
  }, [])

  useEffect(() => {
    !loaded && init(idSending)
    loaded &&
      setTimeout(() => {
        TooltipUtils.rebuild()
      })
  }, [loaded])

  return (
    <>
      <Tooltip />
      <ToastContainer />
      <Loading open={loading} />
      <Header />

      <PageContainer className='email-sending-queue'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => cleanup()}
        />
        {loaded && !error && (
          <>
            <GracePeriodWarning />
            <PecPlusError />
            <PecPlusInProgress />
            <SenderBox />
            <EstimatedTimeBox />
            <ManageRecipients />
            {enableSchedulationRedirect && <BoxSheduleSending />}
            <BoxFasciaDiNonDisturbo />
            <Footer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default EmailSendingQueueManage
